import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { SUBMISSION_KEYS } from './queryKeys';
import type { SubmissionsFilters } from '../types';

export function useSubmissions(
  formId: string,
  filters: SubmissionsFilters,
  page: number,
  pageSize: number,
) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: SUBMISSION_KEYS.list(orgId ?? '', formId, filters, page, pageSize),
    queryFn: ({ signal }) => formsService.getSubmissions(formId, filters, page, pageSize, signal),
    staleTime: 60_000,
    enabled: !!orgId && !!formId,
    placeholderData: keepPreviousData,
  });

  return {
    submissions: data?.data.items ?? [],
    pageInfo: data?.data,
    isLoading,
    isError,
  };
}
